var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,5.3V3H3v14h7v-2.3c0-0.4,0.3-0.7,0.7-0.7h0.6c0.4,0,0.7,0.3,0.7,0.7V18c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2 c0-0.6,0.4-1,1-1h9c0.6,0,1,0.4,1,1v3.3C12,5.7,11.7,6,11.3,6h-0.6C10.3,6,10,5.7,10,5.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,10.7l-3.4,3.4c-0.2,0.2-0.6,0.2-0.8,0L15,13.5c-0.2-0.2-0.2-0.6,0-0.8l1.7-1.7h-7C9.3,11,9,10.7,9,10.3V9.7 C9,9.3,9.3,9,9.7,9h7L15,7.3c-0.2-0.2-0.2-0.6,0-0.8l0.6-0.6c0.2-0.2,0.6-0.2,0.8,0l3.4,3.4C20.2,9.7,20.2,10.3,19.8,10.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout20);
export default __webpack_public_path__ + "static/media/logout-20.d03df6f7b153825154efd82cd3f9f943.svg";
export { ForwardRef as ReactComponent };